import { InjectionToken } from '@angular/core';

export const TV_ICON_PATH_TOKEN = new InjectionToken<string>('TV_ICON_PATH_TOKEN');
